import React from 'react'
import styled from 'styled-components'
import above from '@/utils/above'
import * as UI from '@/components/UI'

export const Section = styled.section`
  padding-bottom: 2rem;
  ${above('sm')`
    padding-bottom: 3rem;
  `}
  ${above('md')`
    padding-bottom: 4rem;
  `}
  ${above('lg')`
    padding-bottom: 5rem;
  `}
  ${above('xg')`
    padding-bottom: 6.25rem;
  `}
`

export const Banner = styled.button`
  display: flex;
  outline: none;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 0.125rem;
  overflow: hidden;
  margin-top: 0.5rem;
  cursor: pointer;
  width: 100%;
  ${above('md')`
    margin-top: 3rem;
  `}
  & > * {
    width: 100%;
  }
`

export const Play = styled.div.attrs({
  children: (
    <UI.Icon.PlayCircle
      color='transparent'
      background='white'
      backgroundOpacity={1}
    />
  ),
})`
  position: absolute;
  width: auto;
  display: block;
  color: ${p => p.theme.colors.white};
  box-shadow: 0 0.25rem 2.5rem 0 rgba(6, 29, 51, 0.2);
  border-radius: 50%;
  svg {
    width: 2.5rem;
    height: 2.5rem;
    ${above('md')`
    width: 4rem;
    height: 4rem;
    `}
  }
`
